
if (document.querySelectorAll('.mood-image-row').length !== 0) {
  const row = document.querySelector('.mood-image-row');
  row.style.transition = 'transform 0.1s';
  let width = row.scrollWidth - row.clientWidth;

  //add resize event listener
  window.addEventListener('resize', () => {
    width = row.scrollWidth - row.clientWidth;
    const elementScrollTop = document.querySelector('.mood-image-row').offsetTop;
    const elementHeight = document.querySelector('.mood-image-row').clientHeight;
    const viewPortHeight = window.innerHeight;
    const scrollPercent = (window.scrollY - elementScrollTop) / (elementHeight - viewPortHeight);
    const leftPosition = Math.min(width, width * scrollPercent);
    document.querySelector('.mood-image-row').style.transform = `translateX(-${leftPosition}px)`;
  });

  window.addEventListener('scroll', () => {
    const elementScrollTop = document.querySelector('.mood-image-row').offsetTop;
    const elementHeight = document.querySelector('.mood-image-row').clientHeight;
    const viewPortHeight = window.innerHeight;
    const scrollPercent = (window.scrollY - elementScrollTop) / (elementHeight - viewPortHeight);
    const leftPosition = Math.min(width, width * scrollPercent);
    document.querySelector('.mood-image-row').style.transform = `translateX(-${leftPosition}px)`;
  });
}

